<template>
    <div class="flex flex-col gap-6">
        <div v-if="!hideTitle" class="tab-header">
            <div class="tab-header-left">
                <h3 class="tab-title">Danger Zone</h3>
            </div>
        </div>

        <!-- Edit Mode (Form) -->
        <div v-if="!viewOnlyMode" class="danger-zone__form">
            <themed-form
                :fields="formFields"
                :model-value="building"
                layout="grid"
                :columns="3"
                @input="updateBuilding"
            />
        </div>

        <!-- View Only Mode -->
        <div v-else class="danger-zone__view grid gap-6 mb-24 md:grid-cols-[repeat(auto-fit,minmax(300px,1fr))] grid-cols-1">
            <div class="flex flex-col gap-3 p-4 rounded-lg bg-card border border-border">
                <div class="flex items-center justify-between">
                    <label class="font-semibold m-0">CMBS</label>
                    <info-icon identifier="sites-dangerzone-cmbs" />
                </div>
                <div class="text-base leading-relaxed max-w-[65ch] whitespace-pre-wrap break-words">
                    {{ building.cmbs || "No Data Found" }}
                </div>
            </div>

            <div class="flex flex-col gap-3 p-4 rounded-lg bg-card border border-border">
                <div class="flex items-center justify-between">
                    <label class="font-semibold m-0">DSCR</label>
                    <info-icon identifier="sites-dangerzone-dscr" />
                </div>
                <div class="text-base leading-relaxed max-w-[65ch] whitespace-pre-wrap break-words">
                    {{ building.dscr || "No Data Found" }}
                </div>
            </div>

            <div class="flex flex-col gap-3 p-4 rounded-lg bg-card border border-border">
                <div class="flex items-center justify-between">
                    <label class="font-semibold m-0">Watchlist Note</label>
                    <info-icon identifier="sites-dangerzone-watchlistnote" />
                </div>
                <div class="text-base leading-relaxed max-w-[65ch] whitespace-pre-wrap break-words">
                    {{ building.watchlist_note || "No Data Found" }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import ThemedForm from '../form/ThemedForm.vue';

export default {
    name: 'BuildingDangerZoneV1',
    
    components: {
        ThemedForm
    },

    props: {
        buildingData: {
            type: Object,
            required: true
        },
        viewOnlyMode: {
            type: Boolean,
            default: true
        },
        hideTitle: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        ...mapState(['buildings']),

        building() {
            return this.buildings.selectedBuilding;
        },

        formFields() {
            return [
                {
                    name: 'cmbs',
                    type: 'textarea',
                    label: 'CMBS',
                    infoIcon: 'sites-dangerzone-cmbs',
                    col: 2,
                    componentProps: {
                        rows: 3,
                        placeholder: 'Enter CMBS information'
                    }
                },
                {
                    name: 'dscr',
                    type: 'number',
                    label: 'DSCR',
                    infoIcon: 'sites-dangerzone-dscr',
                    col: 1,
                    componentProps: {
                        isDecimal: true,
                        placeholder: '0.00'
                    }
                },
                {
                    name: 'watchlist_note',
                    type: 'textarea',
                    label: 'Watchlist Note',
                    infoIcon: 'sites-dangerzone-watchlistnote',
                    col: 3,
                    componentProps: {
                        rows: 3,
                        placeholder: 'Enter watchlist notes'
                    }
                }
            ];
        }
    },

    methods: {
        updateBuilding(updatedData) {
            // Update the building object with new data
            Object.assign(this.building, updatedData);
        }
    }
};
</script>
